
import { motion } from "framer-motion";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Heart } from "lucide-react";
import { JournalEntry } from "./types";

interface ListViewEntryProps {
  entry: JournalEntry;
  onLike: (id: string) => void;
  onDelete: (id: string) => void;
}

export const ListViewEntry = ({ entry, onLike, onDelete }: ListViewEntryProps) => {
  return (
    <motion.div
      key={entry.id}
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: 20 }}
      transition={{ duration: 0.2 }}
    >
      <Card className="p-4 hover:bg-gray-50">
        <div className="flex justify-between">
          <div className="flex gap-4 items-start">
            {entry.notes.images?.length > 0 ? (
              <img
                src={entry.notes.images[0]}
                alt={entry.title}
                className="w-16 h-16 object-cover rounded-md"
              />
            ) : (
              <div className="w-16 h-16 bg-gray-100 rounded-md flex items-center justify-center">
                <span className="text-2xl">📝</span>
              </div>
            )}
            <div>
              <h3 className="font-semibold">{entry.title || "Untitled Entry"}</h3>
              <p className="text-sm text-gray-500">
                {new Date(entry.created_at).toLocaleDateString()}
              </p>
              <p className="text-sm text-gray-600 line-clamp-2 mt-1">
                {entry.notes.text}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <span className="flex items-center gap-1 text-gray-500 text-sm">
              <Heart className={`h-4 w-4 ${entry.likes > 0 ? 'fill-red-500 text-red-500' : ''}`} />
              {entry.likes}
            </span>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => onLike(entry.id)}
            >
              Like
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => onDelete(entry.id)}
            >
              Delete
            </Button>
          </div>
        </div>
      </Card>
    </motion.div>
  );
};
